import axios from "axios";

const ENDPOINT_KEY = "auth";
const ENDPOINT_URI = "/auth";

export default function useAuthService() {
    return {
        queryKey: ENDPOINT_KEY,
        login: async ({
            payload,
        }) => {
            const response = await axios.post(
                `${ENDPOINT_URI}/login`,
                payload
            );
            return response.data;
        },
        getAuthenticatedUser: async () => {
            const response = await axios.get(
                `${ENDPOINT_URI}/me`
            );
            return response.data;
        },
    }
}